import api from './api';

export const recordScores = async (entries) => {
  return (await api.post('/score-history/record', entries)).data;
};

export const getSymbolHistory = async (symbol, days = 30) => {
  return (await api.get(`/score-history/${symbol}`, { params: { days } })).data;
};

export const getScoreChanges = async (minDelta = 0.5, days = 7, direction = null) => {
  const params = { min_delta: minDelta, days };
  if (direction) params.direction = direction;
  return (await api.get('/score-history/changes', { params })).data;
};

export const screenByChanges = async (direction = 'improved', minDelta = 0.5, days = 7) => {
  return (await api.get('/score-history/screen', { params: { direction, min_delta: minDelta, days } })).data;
};
